import type { PurchasesPackage } from 'react-native-purchases'

export interface PurchaseFeedback {
  title: string
  message: string
}

export interface PurchaseScreenState {
  cardHeight: number
  hasResolvedOptions: boolean
  isLoggingOut: boolean
  packages: PurchasesPackage[]
  purchaseFeedback: PurchaseFeedback | null
  selectedPackage: PurchasesPackage | null
}

export type PurchaseScreenAction =
  | { type: 'clearFeedback' }
  | { type: 'resetOptions' }
  | { type: 'setCardHeight'; value: number }
  | { type: 'setLoggingOut'; value: boolean }
  | {
      type: 'setOptions'
      packages: PurchasesPackage[]
      selectedPackage: PurchasesPackage | null
    }
  | {
      type: 'setPurchaseFeedback'
      value: PurchaseFeedback | null
    }

export const initialPurchaseScreenState: PurchaseScreenState = {
  cardHeight: 0,
  hasResolvedOptions: false,
  isLoggingOut: false,
  packages: [],
  purchaseFeedback: null,
  selectedPackage: null,
}

export function purchaseScreenReducer(
  state: PurchaseScreenState,
  action: PurchaseScreenAction,
): PurchaseScreenState {
  switch (action.type) {
    case 'clearFeedback':
      return { ...state, purchaseFeedback: null }
    case 'resetOptions':
      return {
        ...state,
        hasResolvedOptions: false,
        packages: [],
        purchaseFeedback: null,
        selectedPackage: null,
      }
    case 'setCardHeight':
      return state.cardHeight === action.value
        ? state
        : { ...state, cardHeight: action.value }
    case 'setLoggingOut':
      return { ...state, isLoggingOut: action.value }
    case 'setOptions':
      return {
        ...state,
        hasResolvedOptions: true,
        packages: action.packages,
        purchaseFeedback:
          state.selectedPackage?.identifier !==
          action.selectedPackage?.identifier
            ? null
            : state.purchaseFeedback,
        selectedPackage: action.selectedPackage,
      }
    case 'setPurchaseFeedback':
      return { ...state, purchaseFeedback: action.value }
    default:
      return state
  }
}
